{
    "page_header": {
        "title": "Features For Sellers",
        "subtitle": "Where Elevated Experiences, and Sustainability Unite! <br /> Transform your business effortlessly, embrace modern solutions, and join us in making the planet greener.",
        "image": null
    },
    "sections": [
        {
            "section_id": "sellers_features",
            "title": null,
            "subtitle": "",
            "image": null,
            "articleLists": [
                {
                    "id": 12,
                    "title": null,
                    "articles": [
                        {
                            "id": 14,
                            "title": "Cutting-Edge Technology",
                            "subtitle": "",
                            "description": "Stay ahead of the curve with Receeto's cutting-edge technology that is 100% secure. Benefit from continuous innovations and updates to keep your business at the forefront of the industry.",
                            "image": "https://receeto.com/assets/fake-db/images/seller_feature_01.webp"
                        },
                        {
                            "id": 15,
                            "title": "All in Marketing Platform",
                            "subtitle": "",
                            "description": "No need to have a bunch of web platforms in order to create the best marketing strategy or to get info on your performance , with Receeto you will gain valuable insights, reports and much more. All in one place to keep your clients loyal.",
                            "image": "https://receeto.com/assets/fake-db/images/seller_feature_02.webp"
                        },
                        {
                            "id": 16,
                            "title": "Sustainability at its Core",
                            "subtitle": "",
                            "description": "Join us in promoting sustainability by digitizing receipts. Reduce paper waste, contribute to a greener planet, and align your business with eco-friendly practices.",
                            "image": "https://receeto.com/assets/fake-db/images/seller_feature_03.webp"
                        }
                    ]
                }
            ]
        },
        {
            "section_id": "sellers_compare_table",
            "title": "Compare Our Packages",
            "subtitle": "",
            "image": null
        }
    ],
    "banners": [
        {
            "id": 4,
            "banner_id": "sellers_banner_01",
            "title": "Integrate Receeto Today In Your POS For FREE!",
            "subtitle": "",
            "description": "Digitalize your receipt now without any hassle",
            "image": null
        },
        {
            "id": 5,
            "banner_id": "sellers_sub_banner_01",
            "title": "Start your 7 days free trial today",
            "subtitle": "Grow your business with Receeto",
            "description": "Subscribe now to our newsletter to be the first one informed about our updates.",
            "image": "https://receeto.com/assets/fake-db/images/seller_sub_banner.webp"
        }
    ],
    "plans": [
        {
            "id": 1,
            "name": "Seed",
            "title": "Seed Pricing Plan",
            "description": "This plan is designed for businesses seeking to explore the potential of our solution.",
            "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"85\" height=\"85\" viewBox=\"0 0 24 24\">\r\n                <path fill=\"#31C65B\" d=\"M17.2 5c.6 0 1.2 0 1.7.1c.2 2.3.2 6.9-2.5 10.1c-2 2.5-5.4 3.8-10 3.8H5.1c-.2-4.6.7-8.2 2.8-10.5C10.4 5.6 14.4 5 17.2 5m0-2c-5.5 0-15.6 2.1-14 17.8c1.1.1 2.2.2 3.2.2C24.3 21 20.7 3.3 20.7 3.3S19.3 3 17.2 3M17 7C7 7 7 17 7 17C11 9 17 7 17 7\"/>\r\n            </svg>",
            "is_best_deal": false,
            "subPlans": [
                {
                    "plan_id": "sellers_seed_plan_01",
                    "price_per_month": "25 TND",
                    "description": "If billed annually, if not 29 TND / month",
                    "min_number_locations": 1,
                    "max_number_locations": 3
                },
                {
                    "plan_id": "sellers_seed_plan_02",
                    "price_per_month": "15 TND",
                    "description": "If billed annually, if not 19 TND / month",
                    "min_number_locations": 4,
                    "max_number_locations": 15
                },
                {
                    "plan_id": "sellers_seed_plan_03",
                    "price_per_month": null,
                    "description": "If you have more than 16 business locations and wish to integrate our solution, please contact us. We will provide you with an invoice based on the number of locations your business has.",
                    "min_number_locations": 16,
                    "max_number_locations": 100
                }
            ]
        },
        {
            "id": 2,
            "name": "Leaf",
            "title": "Leaf Pricing Plan",
            "description": "This plan is designed for businesses seeking to know more their clients and treat the as a family.",
            "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"65\" height=\"65\" viewBox=\"0 0 24 24\">\r\n                <path fill=\"#31C65B\" d=\"M23 4.1V2.3l-1.8-.2c-.1 0-.7-.1-1.7-.1c-4.1 0-7.1 1.2-8.8 3.3C9.4 4.5 7.6 4 5.5 4c-1 0-1.7.1-1.7.1l-1.9.3l.1 1.7c.1 3 1.6 8.7 6.8 8.7H9v3.4c-3.8.5-7 1.8-7 1.8v2h20v-2s-3.2-1.3-7-1.8V15c6.3-.1 8-7.2 8-10.9M12 18h-1v-5.6S10.8 9 8 9c0 0 1.5.8 1.9 3.7c-.4.1-.8.1-1.1.1C4.2 12.8 4 6.1 4 6.1S4.6 6 5.5 6c1.9 0 5 .4 5.9 3.1C11.9 4.6 17 4 19.5 4c.9 0 1.5.1 1.5.1s0 9-6.3 9H14c0-2 2-5 2-5c-3 1-3 4.9-3 4.9v5z\"/>\r\n            </svg>",
            "is_best_deal": true,
            "subPlans": [
                {
                    "plan_id": "sellers_leaf_plan_01",
                    "price_per_month": "59 TND",
                    "description": "If billed annually, if not 69 TND / month",
                    "min_number_locations": 1,
                    "max_number_locations": 3
                },
                {
                    "plan_id": "sellers_leaf_plan_02",
                    "price_per_month": "39 TND",
                    "description": "If billed annually, if not 49 TND / month",
                    "min_number_locations": 4,
                    "max_number_locations": 15
                },
                {
                    "plan_id": "sellers_leaf_plan_03",
                    "price_per_month": null,
                    "description": "If you have more than 16 business locations and wish to integrate our solution, please contact us. We will provide you with an invoice based on the number of locations your business has.",
                    "min_number_locations": 16,
                    "max_number_locations": 100
                }
            ]
        },
        {
            "id": 3,
            "name": "Tree",
            "title": "Tree Pricing Plan",
            "description": "This plan is designed for companies seeking to run a business according to the rules of the art.",
            "icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"85\" height=\"85\" viewBox=\"0 0 32 32\">\r\n                <path fill=\"#31C65B\" d=\"M12 30H9v-2h3V15.566l-3.515-2.109l1.03-1.714l3.514 2.108A2.011 2.011 0 0 1 14 15.566V28a2.002 2.002 0 0 1-2 2\"/>\r\n                <path fill=\"#31C65B\" d=\"M22 30h-3a2.002 2.002 0 0 1-2-2V17h6a4 4 0 0 0 3.981-4.396A4.149 4.149 0 0 0 22.785 9h-1.583l-.177-.779C20.452 5.696 18.031 4 15 4a6.02 6.02 0 0 0-5.441 3.486l-.309.667l-.863-.114A2.771 2.771 0 0 0 8 8a4 4 0 1 0 0 8v2A6 6 0 1 1 8 6l.079.001A8.027 8.027 0 0 1 15 2c3.679 0 6.692 1.978 7.752 5h.033a6.164 6.164 0 0 1 6.187 5.414A6.001 6.001 0 0 1 23 19h-4v9h3Z\"/>\r\n            </svg>",
            "is_best_deal": false,
            "subPlans": [
                {
                    "plan_id": "sellers_tree_plan_01",
                    "price_per_month": "149 TND",
                    "description": "If billed annually, if not 159 TND / month",
                    "min_number_locations": 1,
                    "max_number_locations": 3
                },
                {
                    "plan_id": "sellers_tree_plan_02",
                    "price_per_month": "99 TND",
                    "description": "If billed annually, if not 109 TND / month",
                    "min_number_locations": 4,
                    "max_number_locations": 15
                },
                {
                    "plan_id": "sellers_tree_plan_03",
                    "price_per_month": null,
                    "description": "If you have more than 16 business locations and wish to integrate our solution, please contact us. We will provide you with an invoice based on the number of locations your business has.",
                    "min_number_locations": 16,
                    "max_number_locations": 100
                }
            ]
        }
    ],
    "feature_groups": [
        {
            "id": 1,
            "title": "Receipts Management",
            "featureLines": [
                {
                    "id": 1,
                    "features": [
                        {
                            "id": 1,
                            "content": "<p>Digital receipt generation <br /> <strong style=\"color: #7857E6;\">(Free)</strong></p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 2,
                            "content": "<p>Digital receipt generation <br /> <strong style=\"color: #7857E6;\">(Free)</strong></p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 3,
                            "content": "<p>Digital receipt generation <br /> <strong style=\"color: #7857E6;\">(Free)</strong></p>",
                            "seller_plan": 3
                        }
                    ]
                },
                {
                    "id": 2,
                    "features": [
                        {
                            "id": 4,
                            "content": "<p>Transactions History</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 5,
                            "content": "<p>Transactions History</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 6,
                            "content": "<p>Transactions History</p>",
                            "seller_plan": 3
                        }
                    ]
                },
                {
                    "id": 3,
                    "features": [
                        {
                            "id": 7,
                            "content": "<p><strong style=\"color: #7857E6;\">Basic</strong> digital receipts design</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 8,
                            "content": "<p><strong style=\"color: #7857E6;\">Advanced</strong> customizable digital receipts</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 9,
                            "content": "<p><strong style=\"color: #7857E6;\">Premium</strong> customizable digital receipts</p>",
                            "seller_plan": 3
                        }
                    ]
                },
                {
                    "id": 4,
                    "features": [
                        {
                            "id": 10,
                            "content": "<p>-</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 11,
                            "content": "<p>Receipts Counting & Export</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 12,
                            "content": "<p>Receipts Counting & Export</p>",
                            "seller_plan": 3
                        }
                    ]
                }
            ]
        },
        {
            "id": 2,
            "title": "Data and Insights",
            "featureLines": [
                {
                    "id": 5,
                    "features": [
                        {
                            "id": 13,
                            "content": "<p><strong style=\"color: #7857E6;\">Basic</strong> Dashboard</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 14,
                            "content": "<p><strong style=\"color: #7857E6;\">Advanced</strong> Dashboard</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 15,
                            "content": "<p><strong style=\"color: #7857E6;\">All In One</strong> Dashboard</p>",
                            "seller_plan": 3
                        }
                    ]
                },
                {
                    "id": 6,
                    "features": [
                        {
                            "id": 16,
                            "content": "<p><strong style=\"color: #7857E6;\">Seed</strong> KPIs</p>\r\n<br />\r\n<ul style=\"list-style: disc;\">\r\n<li>Number of transactions</li>\r\n<li>Global Turnover</li>\r\n<li>Medium Basket</li>\r\n<li>Global Rate</li>\r\n</ul>",
                            "seller_plan": 1
                        },
                        {
                            "id": 17,
                            "content": "<p><strong style=\"color: #7857E6;\">Leaf</strong> KPIs tracking</p>\r\n<br />\r\n<ul style=\"list-style: disc;\">\r\n<li>All Seed KPIs and</li>\r\n<li>Revenu Per Category</li>\r\n<li>Number of loyal customers</li>\r\n<li>Sales index</li>\r\n</ul>",
                            "seller_plan": 2
                        },
                        {
                            "id": 18,
                            "content": "<p><strong style=\"color: #7857E6;\">Tree</strong> KPIs tracking</p>\r\n<br />\r\n<ul style=\"list-style: disc;\">\r\n<li>All Leaf KPIs and</li>\r\n<li>Revenu Per Product</li>\r\n<li>Repeat purchase rates</li>\r\n<li>Purchase frequencies</li>\r\n<li>Lead Capture Rate</li>\r\n<li>Net income</li>\r\n</ul>",
                            "seller_plan": 3
                        }
                    ]
                },
                {
                    "id": 7,
                    "features": [
                        {
                            "id": 19,
                            "content": "<p>-</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 20,
                            "content": "<p><strong style=\"color: #7857E6;\">General</strong> Reporting</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 21,
                            "content": "<p><strong style=\"color: #7857E6;\">Detailed</strong> Reporting</p>",
                            "seller_plan": 3
                        }
                    ]
                },
                {
                    "id": 8,
                    "features": [
                        {
                            "id": 22,
                            "content": "<p>-</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 23,
                            "content": "<p>-</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 24,
                            "content": "<p>CRM fonctionnality</p>",
                            "seller_plan": 3
                        }
                    ]
                }
            ]
        },
        {
            "id": 3,
            "title": "Marketing",
            "featureLines": [
                {
                    "id": 9,
                    "features": [
                        {
                            "id": 25,
                            "content": "<p>10 offers posts / month</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 26,
                            "content": "<p>30 offers posts / month</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 27,
                            "content": "<p>60 offers posts / month</p>",
                            "seller_plan": 3
                        }
                    ]
                },
                {
                    "id": 10,
                    "features": [
                        {
                            "id": 28,
                            "content": "<p>Sponsoring</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 29,
                            "content": "<p>Sponsoring</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 30,
                            "content": "<p>Sponsoring</p>",
                            "seller_plan": 3
                        }
                    ]
                },
                {
                    "id": 11,
                    "features": [
                        {
                            "id": 31,
                            "content": "<p>Feedback Collection</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 32,
                            "content": "<p>Feedback Collection</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 33,
                            "content": "<p>Feedback Collection</p>",
                            "seller_plan": 3
                        }
                    ]
                },
                {
                    "id": 12,
                    "features": [
                        {
                            "id": 34,
                            "content": "<p><strong style=\"color: #7857E6;\">Basic</strong> offers segmentation</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 35,
                            "content": "<p><strong style=\"color: #7857E6;\">Advanced</strong> offers segmentation</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 36,
                            "content": "<p><strong style=\"color: #7857E6;\">Premium</strong> offers segmentation</p>",
                            "seller_plan": 3
                        }
                    ]
                },
                {
                    "id": 13,
                    "features": [
                        {
                            "id": 37,
                            "content": "<p>-</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 38,
                            "content": "<p>Social Media Integration on receipts</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 39,
                            "content": "<p>Social Media Integration on receipts</p>",
                            "seller_plan": 3
                        }
                    ]
                },
                {
                    "id": 14,
                    "features": [
                        {
                            "id": 40,
                            "content": "<p>-</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 41,
                            "content": "<p>-</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 42,
                            "content": "<p>Lead Capturing</p>",
                            "seller_plan": 3
                        }
                    ]
                }
            ]
        },
        {
            "id": 4,
            "title": "Product Management",
            "featureLines": [
                {
                    "id": 15,
                    "features": [
                        {
                            "id": 43,
                            "content": "<p>-</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 44,
                            "content": "<p>Categories performance</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 45,
                            "content": "<p>Categories performance</p>",
                            "seller_plan": 3
                        }
                    ]
                },
                {
                    "id": 16,
                    "features": [
                        {
                            "id": 46,
                            "content": "<p>-</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 47,
                            "content": "<p>-</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 48,
                            "content": "<p>Product performance </p>",
                            "seller_plan": 3
                        }
                    ]
                },
                {
                    "id": 17,
                    "features": [
                        {
                            "id": 49,
                            "content": "<p>-</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 50,
                            "content": "<p>-</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 51,
                            "content": "<p><strong style=\"color: #7857E6;\">Real-time</strong> sales tracking</p>",
                            "seller_plan": 3
                        }
                    ]
                }
            ]
        },
        {
            "id": 5,
            "title": "Taxation",
            "featureLines": [
                {
                    "id": 18,
                    "features": [
                        {
                            "id": 52,
                            "content": "<p>-</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 53,
                            "content": "<p>-</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 54,
                            "content": "<p>Collected <strong style=\"color: #7857E6;\">VAT</strong> (TVA) Calculation</p>",
                            "seller_plan": 3
                        }
                    ]
                }
            ]
        },
        {
            "id": 6,
            "title": "Support",
            "featureLines": [
                {
                    "id": 19,
                    "features": [
                        {
                            "id": 55,
                            "content": "<p><strong style=\"color: #7857E6;\">Basic</strong> support service</p>",
                            "seller_plan": 1
                        },
                        {
                            "id": 56,
                            "content": "<p><strong style=\"color: #7857E6;\">Dedicated</strong> support with priority handling</p>",
                            "seller_plan": 2
                        },
                        {
                            "id": 57,
                            "content": "<p><strong style=\"color: #7857E6;\">24/7 VIP</strong> support</p>",
                            "seller_plan": 3
                        }
                    ]
                }
            ]
        }
    ]
}